import React from "react";
import SpeciesCard from "../shared/SpeciesCard";

/**
 * Species grid component
 * Displays species grouped by category
 * 
 * @param {Object} groupedSpecies - Species grouped by category
 * @param {Object} speciesAreaMap - Map of species to areas
 * @param {Object} speciesImages - Map of species images
 * @param {boolean} loadingImages - Image loading state
 * @param {Array} sounds - Available sounds
 */
export default function SpeciesGrid({
    groupedSpecies,
    speciesAreaMap,
    speciesImages,
    loadingImages,
    sounds,
    fetchSpeciesImage
}) {
    if (!groupedSpecies || Object.keys(groupedSpecies).length === 0) {
        return (
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16">
                <div className="text-center py-16">
                    <p className="text-xl text-charcoal/60">
                        Inga arter hittades som matchar dina filterkriterier.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16">
            {Object.keys(groupedSpecies).sort().map((category) => (
                <div key={category} className="mb-12">
                    {/* Category Title */}
                    <h2 className="font-heading text-3xl font-bold text-forest mb-6">
                        {category}
                    </h2>

                    {/* Species Cards Grid */}
                    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" style={{ gridAutoRows: 'max-content' }}>
                        {groupedSpecies[category].map((specie) => {
                            const sound = sounds?.find((s) => s.species_id === specie.id);
                            const speciesAreas = speciesAreaMap[specie.id] || [];
                            const imageUrls = speciesImages[specie.id] || [];

                            return (
                                <SpeciesCard
                                    key={specie.id}
                                    speciesId={specie.id}
                                    name={specie.name}
                                    images={imageUrls}
                                    loadingImage={loadingImages}
                                    description={specie.description || "Ingen beskrivning tillgänglig"}
                                    habitat={specie.habitat}
                                    areas={speciesAreas}
                                    soundPath={sound?.file_path}
                                    expandable={true}
                                    maxAreasShown={2}
                                    categoryName={specie.category_name}
                                    fetchSpeciesImage={fetchSpeciesImage}
                                />
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
}
